import { createSelector } from 'reselect';
import { getArmyLists } from '../selector';
import { ArmyListView } from './view/ArmyListView';
import { ArmyList } from '@Models';

export const myArmyListsPresenter = createSelector(
  [getArmyLists],
  (armyLists): Array<ArmyListView> => {
    return [...armyLists]
      .sort((a: ArmyList, b: ArmyList) => {
        if (a.versionId != b.versionId) return b.versionId - a.versionId;

        if (a.armyId != b.armyId) return b.armyId - a.armyId;

        return a.name.localeCompare(b.name);
      })
      .map((item) => {
        return new ArmyListView({
          id: item.id,
          name: item.name,
          logo: item.largeLogo,
          initials: item.initials,
          versionName: item.versionName,
          versionColor: item.versionColor,
        });
      });
  },
);
